import React, { useState } from "react";
import { Plus } from "lucide-react";
import { LANDING } from "../../constants/testIds";

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      q: "E se non riesco a lasciarlo?",
      a: "Il percorso serve esattamente a questo. Non ti chiederemo di compiere azioni drastiche se non sei pronta. Lavoriamo prima di tutto sul ricostruire la tua forza interiore e il distacco emotivo: quando sarai pronta, la decisione di allontanarti (o stabilire confini irrevocabili) nascerà in modo naturale e senza sforzo."
    },
    {
      q: "È adatto anche se sono ancora all'interno della relazione?",
      a: "Assolutamente sì. Non importa in quale fase ti trovi. Il cambiamento non inizia modificando l'esterno o la relazione, ma modificando la posizione da cui scegli di amare. Moltissime donne iniziano il percorso mentre sono ancora all'interno di una relazione complessa."
    },
    {
      q: "Si tratta di psicoterapia?",
      a: "No. Questo non è un percorso di psicoterapia o un trattamento di carattere medico. Si tratta di Coaching Strategico e Trasformazionale mirato all'azione, all'acquisizione di standard personali, alla decodifica dei comportamenti e alla ricostruzione pratica dell'autostima."
    },
    {
      q: "Quanto tempo e impegno richiede a settimana?",
      a: "Richiede circa 1 ora a settimana per la sessione individuale live con Giulia, e circa 10-15 minuti al giorno per gli esercizi pratici e di introspezione. È strutturato per integrarsi perfettamente nella vita lavorativa e personale di una donna impegnata."
    },
    {
      q: "Come si svolge e come funziona concretamente?",
      a: "È un percorso individuale di 60 giorni. Comprende sessioni live settimanali online via Zoom, un canale di supporto quotidiano diretto su WhatsApp con Giulia per sciogliere i dubbi del momento, e un kit di strumenti ed esercizi pratici personalizzati."
    }
  ];

  const toggleFaq = (idx) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section id="faq" className="py-24 md:py-32 bg-white">
      <div className="max-w-4xl mx-auto px-6 md:px-12 space-y-16">
        
        {/* Title */}
        <div className="text-center space-y-4 max-w-xl mx-auto">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-bordeaux">
            DOMANDE FREQUENTI
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-chocolate font-editorial">
            Risolvi i tuoi <span className="italic">dubbi</span>
          </h2>
          <p className="text-sm text-chocolate/70 font-light">
            Ecco le risposte trasparenti alle domande e alle perplessità più comuni delle nostre candidate.
          </p>
        </div>

        {/* Flat Accordion */}
        <div className="border-t border-chocolate/20">
          {faqs.map((faq, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div 
                key={idx} 
                className="border-b border-chocolate/20 py-6 transition-luxury"
              >
                <button
                  onClick={() => toggleFaq(idx)}
                  className="w-full flex items-center justify-between text-left text-chocolate hover:text-bordeaux focus:outline-none group"
                  data-testid={`${LANDING.faqTrigger}-${idx}`}
                >
                  <span className="text-base sm:text-lg font-normal font-editorial tracking-wide">
                    {faq.q}
                  </span>
                  <Plus 
                    className={`w-5 h-5 text-chocolate/60 group-hover:text-bordeaux transition-transform duration-300 shrink-0 ${
                      isOpen ? "rotate-45 text-bordeaux" : ""
                    }`} 
                  />
                </button>

                {isOpen && (
                  <div className="mt-4 text-sm sm:text-base leading-relaxed text-chocolate/80 font-light font-sans animate-fade-in">
                    {faq.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
}
